// sd-todo: this file is not being used right now and can be removed in the next release
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as nocDashboard from '@store/noc/dashboard/actions';
import { initTempDashboard } from '@store/noc/tempDashboard/actions';
import tempDashboardStateSelector from '@store/noc/selectors';
import tempDashboardSelector from '@store/noc/tempDashboard/selectors';
import { dashboardResponseSelector, dashboardIsFetchingSelector } from '@store/noc/dashboard/selectors';
import { DASHBOARD_TYPE } from '@utils/constants';
import { selector as filterContainerSelector } from '@store/filterContainer';
import { filterIndicesSelector } from '@store/comparison/selectors';
import { changeFilterContainerVisibility } from '@store/filterContainer/actions';
import dashboard from '../common/dashboard';
import NocComponent from './NocComponent';

const selectors = createSelector(
  dashboardResponseSelector,
  dashboardIsFetchingSelector,
  tempDashboardStateSelector,
  tempDashboardSelector,
  filterContainerSelector,
  filterIndicesSelector,
  (response, isFetching, dashboardState, tempDashboard, filterContainer, filterIndices) => ({
    response,
    isFetching,
    dashboardType: DASHBOARD_TYPE.NOC,
    dashboard: dashboardState,
    nocStore: dashboardState,
    tempIsFetching: tempDashboard.isFetching,
    filterContainer,
    filterIndices,
  }),
);

const NocDashboard = compose(
  connect(selectors, {
    initTempDashboard,
    initDashboard: nocDashboard.initRequest,
    getDashboard: nocDashboard.getDashboard,
    fetchingAction: nocDashboard.fetching,
    changeFilterContainerVisibility,
  }),
  dashboard(),
)(NocComponent);

export default NocDashboard;
